import { Box } from '@mui/material'
import { Page_Padding } from '../../shared/constants'
import CustomDivider from '../../shared/utils/CustomDivider'
import ElyfDefferenceSection from './ElyfDefferenceSection'
import CurriculumSection from './CurriculumSection'
import HeroSection from './HeroSection'
import ValueEditionOfElyfSection from './ValueEditionOfElyfSection'
import AboutElyfSection from './AboutElyfSection'
import { usePageContentWithMeta } from '../../shared/hook/usePageContentWithMeta'
import { useEffect } from 'react'
// import { usePageContentWithMeta } from '../../shared/hook/usePageContentWithMeta'

const EducationForLife = ({ onLoadingChange = () => { } }) => {
    const { data: Detail, isLoading } = usePageContentWithMeta("ELYF");
    useEffect(() => {
        onLoadingChange(isLoading);
    }, [isLoading, onLoadingChange]);
    if (isLoading) return null;
    return (
        <Box >
            <HeroSection bottomData={Detail?.content[1]?.data} heroData={Detail?.content[0]?.data} />
            <Box className="body contact_us">
                <AboutElyfSection aboutElyfData={Detail?.content[2]?.data} />
                <Box px={Page_Padding}>
                    <CustomDivider />
                    <CustomDivider />
                    <ElyfDefferenceSection differenceElyfData={Detail?.content[3]?.data} />
                    <CustomDivider />
                    <CurriculumSection curriculumElyfData={Detail?.content[4]?.data} />
                    <CustomDivider />
                    <ValueEditionOfElyfSection valueEditionElyfData={Detail?.content[5]?.data} />
                </Box>
            </Box>
        </Box>
    )
}

export default EducationForLife
